"use strict";
/**
 * The Configuration module enables interaction with all the data needed
 * for exploring a Configuration and the Options available.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceError = exports.DefaultConfigurationService = exports.BaseConfigurationService = exports.ConfigurationService = void 0;
var configurationService_1 = require("./configurationService");
Object.defineProperty(exports, "ConfigurationService", { enumerable: true, get: function () { return configurationService_1.ConfigurationService; } });
Object.defineProperty(exports, "BaseConfigurationService", { enumerable: true, get: function () { return configurationService_1.BaseConfigurationService; } });
Object.defineProperty(exports, "DefaultConfigurationService", { enumerable: true, get: function () { return configurationService_1.DefaultConfigurationService; } });
var errors_1 = require("./errors");
Object.defineProperty(exports, "ServiceError", { enumerable: true, get: function () { return errors_1.ServiceError; } });
